module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/14f9d56d55436cf7fad1167a0261f318.png";